<template lang="pug">
  v-col()
    v-row( justify='start' align='center' ).fill-height
      template( v-for='item of Productos' )
        v-col(cols=12 md=4)
          Producto_item(:item='item')
        
</template>
<script>
export default {

  computed: {

    Productos(){
      return this.$contenido.Lineas_Comerciales ? this.$contenido.Lineas_Comerciales.productos.filter( i => i.categoria == this.categoria) : []
    },
    categoria(){
      return this.$route.params.categoria
    },
    linea_comercial(){
      return this.$route.params.linea_comercial
    },
  },
  components: {
    Producto_item: ()=>import('./Producto_item')
  }
 
}
</script>